var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var PinterestLightSvg = /* @__PURE__ */ __name(function PinterestLightSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M10.812 17.64c-1.931-0.264-2.816-1.062-3.225-2.598-1.326-4.985 2.453-9.869 7.914-10.131 0.166-0.008 0.361-0.013 0.556-0.013 1.030 0 2.031 0.127 2.987 0.367l-0.084-0.018c4.609 1.133 6.708 5.282 5.276 10.261-0.946 3.29-3.014 5.382-5.799 5.444-1.299 0.029-2.612-0.546-4.048-0.878-0.668 2.252-0.921 5.032-3.309 7.027-0.377-2.469-0.077-4.658 0.473-6.831 0.243-0.965 0.46-1.931 0.715-2.886 0.166-0.595 0.261-1.279 0.261-1.984 0-0.455-0.040-0.9-0.116-1.333l0.007 0.046c-0.164-1.051 0.229-2.287 0.676-3.307 0.413-0.935 1.389-1.274 2.432-0.853s1.209 1.302 0.989 2.26c-0.299 1.344-0.796 2.655-1.001 4.006-0.102 0.676 0.033 1.744 0.473 2.060 0.593 0.425 1.69 0.579 2.376 0.328 0.813-0.302 1.607-1.047 2.075-1.807 1.072-1.738 1.38-3.719 1.020-5.74-0.505-2.834-2.747-4.414-5.769-4.146-3.154 0.281-5.844 3.009-5.844 6.062 0 0.781 0.386 1.558 0.552 2.346 0.159 0.729 0.264 1.467 0.413 2.32z"
  }));
}, "PinterestLightSvg");
var PinterestLightIcon = /* @__PURE__ */ __name(function PinterestLightIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: PinterestLightSvg
  }, props));
}, "PinterestLightIcon");
export {
  PinterestLightIcon
};
